import { render } from "./SubmitSubProjectModal.vue?vue&type=template&id=df2049be&scoped=true"
import script from "./SubmitSubProjectModal.vue?vue&type=script&lang=js"
export * from "./SubmitSubProjectModal.vue?vue&type=script&lang=js"

import "./SubmitSubProjectModal.vue?vue&type=style&index=0&id=df2049be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df2049be"]])

export default __exports__